import styled from 'styled-components'

export const ServiceIcon = styled.span<{ $color: string; $inactive: boolean }>(
  ({ theme, $color, $inactive }) => ({
    alignItems: 'center',
    backgroundColor: $color,
    borderRadius: theme.border.radius['8'],
    color: theme.colors.white,
    display: 'flex',
    flexShrink: 0,
    // Note: smaller than the row's text block (title 2rem + subtitle 1.6rem + gap), so it never sets the row height
    height: '3.6rem',
    justifyContent: 'center',
    opacity: $inactive ? 0.5 : 1,

    svg: {
      maxHeight: '2.2rem',
      maxWidth: '2.2rem',
    },
    width: '3.6rem',
  }),
)
